import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { logger } from "@services/workers/helpers";
import StorageUtils from "@services/storage";
import { UIKeys, uiTemplate } from "@services/storage/storeTemplate";
const namespace = "UIReducer";
export const storeName = "ui";
export const templateState = uiTemplate();
export const initialState = uiTemplate();
export interface Action {
  name?: UIKeys;
  value: any;
}
export const uiSlice = createSlice({
  initialState,
  name: storeName,
  reducers: {
    hydrate: (state, action: PayloadAction<Action>) => {
      // logger.debug(namespace + "->" + hydrate.name, "Hydrating state");
      return { ...initialState, ...action.payload.value };
    },
    loaded: (state) => {
      // logger.debug(namespace + "->" + uiSlice.name, "Loaded state");
      state.Loading = false;
    },
    loading: (state) => {
      // logger.debug(namespace + "->" + uiSlice.name, "Loading state");
      state.Loading = true;
    },
    reset: (state, action: PayloadAction<Action>) => {
      // logger.debug(namespace + "->" + uiSlice.name, "Reset state");
      return { ...initialState, ...action.payload.value, Done: true };
    },
    resetSquare: (state) => {
      // logger.debug(namespace + "->" + uiSlice.name, "Reset square state");
      return {
        ...state,
        SquareCard: null,
        SquareCardBrand: "",
        SquareCardData: null,
        SquareCustomerId: null,
        SquareDisabled: true,
        SquareEnableVerifyBuyer: false,
        SquareEnableWebSDK: true,
        SquareError: null,
        SquareFocus: "cardNumber",
        SquareFormLoaded: false,
        SquareInfo: "Please enter card details and press STORE.",
        SquareLoaded: false,
        SquareNonce: null,
        SquarePaymentData: null,
        SquarePaymentForm: null,
        SquareProcessing: false,
        SquareResetEnabled: false,
        SquareSucceeded: false,
        SquareUserChallenged: undefined,
        SquareVerification: null,
      };
    },
    resetWithCache: (state, action: PayloadAction<Action>) => {
      // logger.debug(namespace + "->" + uiSlice.name, "Reset state with cache");
      return { ...initialState, ...action.payload.value, Done: false };
    },
    save: (state) => {
      for (const key in state) {
        StorageUtils.saveToStorage({
          key,
          store: storeName,
          type: "local",
          value: state[key as keyof typeof state],
        });
      }
    },
    set: (state, action: PayloadAction<Action>) => {
      // if payload value is object, then log
      if (typeof action.payload.value === "object") {
        logger.debug(namespace + "->" + uiSlice.name, `Set ${action.payload.name}`, action.payload.value);
      }

      if (action.payload.name) {
        state[action.payload.name] = action.payload.value as never;
      }
    },
    setMultiple: (state, action: PayloadAction<Action>) => {
      // logger.debug(namespace + "->" + setMultiple.name, "Setting multiple state");
      return { ...state, ...action.payload.value };
    },
    setSnackMsg: (state, action: PayloadAction<Action>) => {
      logger.debug(namespace + "->" + setSnackMsg.name, "Setting snack message", action.payload.value);
      const { ProblemMsg, ProblemMsgVariant, ProblemShowMsg } = action.payload.value;
      return { ...state, ProblemMsg, ProblemMsgVariant, ProblemShowMsg };
    },
  },
});
export const { actions, reducer } = uiSlice;
export const { hydrate, loaded, loading, reset, resetSquare, resetWithCache, save, set, setMultiple, setSnackMsg } =
  actions;
export const uiSelector = (state: RootState) => state.ui;
